import { useQuery } from '@tanstack/react-query';
import { getConversations } from '../api/messageApi';
import { ConversationsResponse } from '../types';

/**
 * Hook for managing conversations list
 * 
 * @param page - Page number
 * @param limit - Items per page
 */
export const useConversations = (page = 1, limit = 20) => {
  return useQuery<ConversationsResponse>({
    queryKey: ['conversations', page, limit],
    queryFn: () => getConversations(page, limit),
    staleTime: 30000, // 30 seconds
  });
};

